<template>
  <collection-container
    :active="activeChapter"
    :items="chapters"
    label="Chapter"
    :loading="isLoading"
    @selected="setSelected"
    @pdf="toPdf"
    @update="assign"
    empty-collection-label="Please add a chapter first."
    @sort="sortCollection"
    @delete="deassign"
    @delete-collection="deleteCollection"
  >
    <core-button
      label="Add Chapter"
      :icon="icons.add"
      @click="$router.push({ query: { dialog: 1, form: 'add_chapter' } })"
    />
  </collection-container>
</template>
<script>
import CollectionContainer from './CollectionContainer';
import { mapActions, mapState } from 'vuex';
import { GetterType } from '../../config/constants';
import moment from 'moment';
import icons from '../../mixins/icons';
import CoreButton from '../core/buttons/CoreButton';

export default {
  components: { CoreButton, CollectionContainer },
  mixins: [icons],
  computed: {
    ...mapState('chapters', {
      activeChapter: state => state.active,
      chapters: state => state.items
    }),
    ...mapState('product', {
      selectedProductCountry: state => state.selected
    })
  },
  data() {
    return {
      isLoading: false
    };
  },
  mounted() {
    const { presentation } = this.$route.query;
    if (presentation) {
      const chapter = this.$store.getters['chapters/getChapterById'](presentation);
      if (chapter) {
        this.$store.commit('chapters/setActive', chapter);
      }
    }
  },
  methods: {
    ...mapActions({
      setActive: 'chapters/setActiveChapter',
      assignSlideToChapter: 'chapters/assignSlideToChapter',
      sortChapter: 'chapters/sortChapter',
      deassignSlideFromChapter: 'chapters/deassignSlideFromChapter',
      getChapters: 'chapters/getFiltered',
      deleteChapter: 'chapters/deleteChapter'
    }),
    async assign(data) {
      await this.assignSlideToChapter({ chapter: data.collection, slide: data.slide, pos: data.pos });
    },
    async sortCollection(data) {
      await this.sortChapter({
        chapter: data.collection,
        slide: data.slide,
        oldPos: data.oldPos,
        newPos: data.newPos
      });
    },
    async deassign(data) {
      await this.deassignSlideFromChapter({ chapter: data.collection, slide: data.slide, pos: data.pos });
    },
    setSelected(selected) {
      this.setActive(this.chapters.filter(item => item._id === selected).pop());
    },
    deleteCollection(event) {
      this.deleteChapter(event.id)
        .then(() => {
          this.$store.dispatch('alerts/success', 'Deleted Chapter successfully');
        })
        .catch(() => {
          this.$store.dispatch('alerts/warning', 'Not able to delete flow, please try again!');
        });
    },
    async toPdf(chapter) {
      this.isLoading = true;
      if (chapter) {
        let name = chapter.name;
        let downloadName = `${moment().format('YYYYMMDD')}-${this.selectedProductCountry.product.name}-${
          this.selectedProductCountry.country
        }-${name.trim()}.pdf`;
        let id = chapter._id;
        const { ExportService } = require('@/services/modules/export');
        new ExportService()
          .asPdf(id, GetterType.chapter, downloadName)
          .then(link => {
            this.isLoading = false;
            link.click();
          })
          .catch(() => (this.isLoading = false));
      }
    }
  }
};
</script>
